/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Uppercase_HelpInputs */



/**
* | output |
* | --- |
* | "Auto capitalize words at the beginning of sentences" |
*
* @param {Auto_Uppercase_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_uppercase_help = /** @type {((inputs?: Auto_Uppercase_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Uppercase_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre automatiquement en majuscule les mots en début de phrase")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter am Satzanfang automatisch großschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mettere automaticamente in maiuscolo le parole all'inizio delle frasi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое добавление заглавных букв в начало предложений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Capitalizar automáticamente las palabras al principio de las oraciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动将句首单词大写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文頭の単語を自動で大文字にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वाक्यों के आरंभ में आने वाले शब्दों को स्वतः बड़े अक्षरों में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Capitalizar automaticamente as palavras no início das frases.")
	return /** @type {LocalizedString} */ ("Auto capitalize words at the beginning of sentences")
});